import { ref } from 'vue'

// Shared between the grid's row-selection checkboxes (wired via `rowsSelection`
// in useTable.js) and ExecRoutesBridge (which turns the checked rows into map
// data) - the two live in separate branches of DataTable's component tree, so
// a plain module-level ref is simpler than threading a prop/event pair through
// DataTable. Same pattern as `useScreenView.js`.
export const selectedExecRoutes = ref([])

// Total routes matching the grid's current filters (from the fetch's own
// pagination meta, not just the current page) - useTable.js hides the
// checkboxes once this drops to 1 or 0, since there's nothing meaningful to
// pick between.
export const routesCount = ref(0)

let isAutoSelected = false

export const setSelectedExecRoutes = (rows) => {
  isAutoSelected = false
  selectedExecRoutes.value = Array.isArray(rows) ? rows : []
}

export const setRoutesCount = (count) => {
  routesCount.value = Number.isFinite(count) ? count : 0
}

// Called on every grid fetch. With exactly one route there's nothing to
// check a box for, so show it automatically instead of leaving the map
// empty forever (checkboxes are hidden in that case too - see useTable.js).
// If the route count later grows back past one, this clears the
// auto-selection again so the map doesn't keep showing a route with no
// checkbox actually checked for it - but only when THIS function put it
// there; a real user selection (via the checkboxes) is left untouched.
export const autoSelectSingleRoute = (rows, total) => {
  if (total === 1 && Array.isArray(rows) && rows.length === 1) {
    isAutoSelected = true
    selectedExecRoutes.value = rows
  }
  else if (isAutoSelected) {
    isAutoSelected = false
    selectedExecRoutes.value = []
  }
}
